import styled from 'styled-components';

export const CareersSection = styled.div`
    position: relative;
    
    &:after{
        position: absolute;
        content: "";
        width:100%;
        height: 100%;
        background-color:#F1FEFF;
        top: 62px;
        z-index: -1;
    }
`;

export const SupportMission=styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding:20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -110px;
    margin-bottom:60px;
    gap:40px;

    @media screen and (max-width: 991px){ 
        flex-direction: column;
        align-items: flex-start;
        gap: 30px;
        margin-bottom: 50px;
    }

    @media screen and (max-width: 767px){
        padding: 20px;
    }

    @media screen and (max-width: 575px){
        margin-bottom: 40px;
    }
`;

export const SupportMissionContent=styled.div`
    width:100%;
    max-width:522px;

    @media screen and (max-width: 991px){
        max-width: 100%;
    }

    button {
        padding: 12px 67px;
    }
`;

export const SupportMissionText=styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight:400;
    line-height: 27px;
    margin-bottom:30px;
    strong{
        color:#01606F;
        font-weight:700;
    }
    &:last-child{
        margin-bottom:0px;
    }
    a{
        text-decoration: none;
        &:hover{
            strong{
                color:#333;
            }
           
        }
    }
`;

export const SupportImage=styled.div`
    img{ 
       width:100%;
       display: block;
    }
`;

export const OurImpactTitle=styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 700;
    line-height: 40px;
    margin-bottom: 15px;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }
`;

export const Opening=styled.div`
    background: #F1FEFF 0% 0% no-repeat padding-box;
    padding-bottom: 50px;

    @media screen and (max-width: 575px){
        padding-bottom: 40px;
    }
    
`;

export const OpeningTitle=styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 700;
    line-height: 40px;
    margin-bottom: 30px;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
        margin-bottom: 20px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }
`;

export const OpeningPosition=styled.div`
    display: flex;
    gap: 20px;
    width: 100%;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding:10px;
    align-items: center;
    margin-bottom:20px;

    @media screen and (max-width: 991px){ 
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const OpeningPositionDetail=styled.div`
    width: 100%;
    max-width: 871px;
`;

export const OpeningImage=styled.div`
    background: #FFD495 0% 0% no-repeat padding-box;
    border-radius: 10px;
    width:100px;
    min-width:100px;
    height:100px;
    display: flex;
    align-items: center;
    justify-content: center;
     
    @media screen and (max-width: 575px){
        width:60px;
        min-width:60px;
        height:60px;
    }

    img{
        width: 100%;
        max-width: 60px;

        @media screen and (max-width: 575px){
            max-width: 30px;
        }
    }
`;

export const PositionTitle=styled.h3`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 700;
    line-height: 25px;
    margin-bottom: 15px;
`;

export const PositionList=styled.ul`
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    gap: 103px;

    @media screen and (max-width: 991px){
        gap: 70px;
    }

    @media screen and (max-width: 480px){
        flex-direction: column;
        row-gap: 15px;
    }
`;

export const PositionItem=styled.li`
    position: relative;
    &:after{
        position: absolute;
        content: "";
        width: 2px;
        height: 30px;
        background-color: rgb(51 51 51 / 50%);
        right: -50px;

        @media screen and (max-width: 991px){ 
            right: -40px;
            top: 0;
            height: 50px;
        }

        @media screen and (max-width: 480px){
            display: none;
        }
    }
    &:last-child{
        &:after{
            display:none;
        }
    }
`;

export const PositionExperience=styled.strong`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 700;
    line-height: 25px;
    margin-bottom: 0px;
`;

export const PositionYear=styled.span`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 400;
    line-height: 25px;
    margin-bottom: 0px;
    display: inline-block;
    padding-left: 7px; 
`;

export const ApplyNowBtn=styled.div`
    display: flex;
    align-items: center;
    justify-content: end;

    button{
        padding: 12px 30px;
        min-width: 158px;

        @media screen and (max-width: 991px){ 
            min-width: inherit;
        }
    }
`;

export const OpeningSection=styled.div``;

export const NoOpening=styled.div``;

export const NoOpeningTitle=styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:24px;
    font-weight: 700;
    line-height: 75px;
    margin-bottom: 0px;
    text-align: center;
`;

export const NoOpeningImage=styled.div`
    img{
        display: block;
        margin: 0 auto;
        width:100%;

    }
`;

